export enum EnterpriseOptionType {
  // Users and calls
  CentrexUsers = 'CentrexUsers',
  // virtual users is also a virtual enteprise option existing only on front-end
  VirtualUsers = 'VirtualUsers',
  ResidentialUsers = 'ResidentialUsers',
  ConcurrentCalls = 'ConcurrentCalls',
  BusinessTrunkChannels = 'BusinessTrunkChannels',
  MicrosoftTeamsUsers = 'MicrosoftTeamsUsers',
  MicrosoftTeamsTrunkChannels = 'MicrosoftTeamsTrunkChannels',
  Microsoft365PresenceSyncFeatures = 'Microsoft365PresenceSyncFeatures',
  // Enterprise services
  ABRoutingService = 'ABRoutingService',
  RichPresenceService = 'RichPresenceService',
  InstantMessagingService = 'InstantMessagingService',
  IvrAssistants = 'IvrAssistants',
  DedicatedConferences = 'DedicatedConferences',
  // User features
  AdHocConferenceFeatures = 'AdHocConferenceFeatures',
  InstantMessagingFeatures = 'InstantMessagingFeatures',
  CollaborationFeatures = 'CollaborationFeatures',
  CstaFeatures = 'CstaFeatures',
  FaxmailFeatures = 'FaxmailFeatures',
  VoicemailFeatures = 'VoicemailFeatures',
  SingleNumberFeatures = 'SingleNumberFeatures',
  // Softclients
  DesktopOperator = 'DesktopOperator',
  DesktopCti = 'DesktopCti',
  DesktopCommunicator = 'DesktopCommunicator',
  MobileCommunicator = 'MobileCommunicator',
  MobileOffice = 'MobileOffice',
  WebCommunicator = 'WebCommunicator',
  // Call recording
  CallRecPermanentAPI = 'CallRecPermanentAPI',
  CallRecService = 'CallRecService',
  CallRecPermanentFeatures = 'CallRecPermanentFeatures',
  // Call center
  CallCenterAgents = 'CallCenterAgents',
  CallCenterPremiumAgents = 'CallCenterPremiumAgents', // deprecated
  CallCenterSupervisors = 'CallCenterSupervisors',

  PhysicalDevices = 'PhysicalDevices',
  TextToSpeech = 'TextToSpeech',
  // Fallback option
  UnknownOption = 'UnknownOption',
}
